<app-beta-notice></app-beta-notice>


<app-header class="z-50"></app-header>
<app-canvas></app-canvas>
<info-area class="pointer-events-none z-10"></info-area>


<main class="pt-32 flex flex-col flex-grow md:pt-64 lg:pt-52">
    <div class="w-screen flex justify-center">
        <div class="container flex justify-between">
            <div class="flex space-x-2">
                <div #lamellaAreaGroups class="flex space-x-2">
                    <!-- Ryhmä -napit -->
                    @for (lamelareaGroup of lamelareaStore.lamellaAreaGroups(); track lamelareaGroup ) {
                        <button #lamelAreaGroup [id]="lamelareaGroup.id" type="button" class="text-zinc-500 px-4 py-2 rounded-t-md cursor-pointer flex gap-2 group" [attr.data-cy]="'lamella-area-group-'+ $index"
                                (click)="selectLamelAreaGroup(lamelareaGroup.id)"
                                [ngClass]="lamelareaStore.selectedLamellaAreaGroupId() === lamelareaGroup.id ? 'bg-primary-50' : 'bg-zinc-50'">
                            @if (groupListeners[lamelareaGroup.id]?.change()) {
                                <app-input class="max-w-24" #lamelAreaGroupInput [initialValue]="lamelareaGroup.name" (valueChange)="renameGroup(lamelareaGroup.id, $event.value)" [inputPadding]="0" />
                            } @else {
                                <span>{{ lamelareaGroup.name }}</span>
                                @if ($count > 1){
                                    <img src="assets/images/icons/close-slate.svg" alt="" class="max-h-6 m-auto align-middle hover:animate-wiggle hover:animate-infinite" (click)="removeGroup(lamelareaGroup.id)" />
                                }
                            }
                        </button>
                    }
                </div>
                <span data-cy="add-group"
                     (click)="addGroup()"
                     class="text-white font-semibold tracking-wider px-4 py-2 rounded-t-md cursor-pointer bg-secondary-400 text-overflow-hidden">
                        {{ "MAIN_LAYOUT.ADD_LAMELLA_AREA" | translate }}
                </span>
            </div>
            <app-save-component/>
        </div>
    </div>
    <div class="w-screen flex justify-center">
        <div class="bg-zinc-50 p-4 md:container">
            <div class="flex flex-col">
                @for (lamelarea of lamelareaStore.getLamelareas(); track lamelarea.id) {
                    <app-product-card class="m-2" data-cy="lamella-area" [lamelareaId]="lamelarea.id"/>
                }
            </div>
            <div class="flex flex-col mt-4">
                <button class="bg-primary-500 text-white px-4 py-2 rounded-md cursor-pointer w-48" data-cy="create-lamella-area"
                        (click)="lamelareaStore.createLamelarea()">
                    {{ 'BUTTONS.ADD_NEW_LAMELLA_AREA' | translate }}
                </button>
            </div>
        </div>
    </div>
</main>

<app-footer></app-footer>



